var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is.loading)?_c('loader'):[_c('order-basket',{attrs:{"order":_vm.entity}}),_c('br'),_c('order-actions',{attrs:{"entityKey":_vm.eParent.key,"order":_vm.entity}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }